export enum KeyboardAction {
  CAMERA_FORWARD,
  CAMERA_BACKWARD,
  CAMERA_RIGHT,
  CAMERA_LEFT,
  CAMERA_UP,
  CAMERA_DOWN,
  CAMERA_LOOK_RIGHT,
  CAMERA_LOOK_LEFT,
  CAMERA_LOOK_UP,
  CAMERA_LOOK_DOWN,
  CAMERA_TWIST_RIGHT,
  CAMERA_TWIST_LEFT,
  CAMERA_ROTATE_RIGHT,
  CAMERA_ROTATE_LEFT,
  CAMERA_ROTATE_UP,
  CAMERA_ROTATE_DOWN,
  CAMERA_ZOOM_IN,
  CAMERA_ZOOM_OUT,
}
